import apiService from '@/services/apiService';

const actions = {
  getAllPaymentLimitationWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-setting/payment-limitation/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getPaymentLimitation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.get(`cx/claim-setting/payment-limitation/find-by-id/${payload}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getClaimUsers({ commit }) {
    return new Promise((resolve, reject) => {
      apiService.get('cx/claim-setting/users?setting_type=payment_limitation')
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  },
  createPaymentLimitation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('cx/claim-setting/payment-limitation', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePaymentLimitation({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`cx/claim-setting/payment-limitation/update/${payload.id}`, payload.formData)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deletePaymentLimitation({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.delete(`cx/claim-setting/payment-limitation/delete/${payload}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
};

export default actions;